export default __webpack_public_path__ + "static/media/variableAclConfigured.a11e12c2.svg";